<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="CONTA_CONTABIL"
          label="Conta contábil"
          class="rounded-tag-small"
          v-model="formData.contaContabil"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
